import {
  ClipboardList,
  LayoutDashboard,
  Package,
  ShieldCheck,
  Store,
  Tag,
  Truck,
  UserPlus,
  Users,
  Wallet,
  BarChart3,
  MapPin,
} from "lucide-react";

export const vendorNav = [
  { key: "orders", to: "/vendor", label: "Live orders", icon: LayoutDashboard, end: true },
  { key: "products", to: "/vendor/products", label: "Products", icon: Package },
  { key: "store", to: "/vendor/store", label: "My store", icon: Store },
];

export const driverNav = [
  { key: "deliveries", to: "/driver", label: "Deliveries", icon: MapPin, end: true },
  { key: "earnings", to: "/driver/earnings", label: "Earnings", icon: Wallet },
];

export const adminNav = [
  { key: "overview", to: "/admin", label: "Overview", icon: BarChart3, end: true },
  { key: "vendors", to: "/admin/vendors", label: "Vendors", icon: Store },
  { key: "orders", to: "/admin/orders", label: "Orders", icon: ClipboardList },
  { key: "drivers", to: "/admin/drivers", label: "Drivers", icon: Truck },
  { key: "users", to: "/admin/users", label: "Users", icon: Users },
  { key: "invites", to: "/admin/invites", label: "Invites", icon: UserPlus },
  { key: "promotions", to: "/admin/promotions", label: "Promotions", icon: Tag },
  { key: "categories", to: "/admin/categories", label: "Categories", icon: LayoutDashboard },
  { key: "compliance", to: "/admin/compliance", label: "Compliance", icon: ShieldCheck },
  { key: "hero", to: "/admin/hero-stats", label: "Hero stats", icon: BarChart3 },
];
